import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

// const ModalBox = props => (
//   <div className={`ModalBox scale-transition ${props.modalActive ? 'active' : 'scale-out'}`}>
//     {props.modalActive && (
//       <div className="ModalBox__wrapper">
//         <div className="ModalBox__header">
//           <div
//             className="ModalBox__header--icon"
//             role="button"
//             tabIndex={0}
//             onClick={() => props.onChange(false)}
//           />
//           <div className="ModalBox__header--label">{props.modalLabel}</div>
//         </div>
//         <div className="ModalBox__content">{props.children}</div>
//       </div>
//     )}
//   </div>
// );

class ModalBox extends Component {
  componentWillReceiveProps = props => {
    if (props.modalActive && !this.props.modalActive) window.scrollTo(0, 0);
  };

  render() {
    const { props } = this;

    return (
      <div className={`ModalBox scale-transition ${props.modalActive ? 'active' : 'scale-out'}`}>
        {props.modalActive && (
          <div className="ModalBox__wrapper">
            <div className="ModalBox__header">
              <div
                className="ModalBox__header--icon"
                role="button"
                tabIndex={0}
                onClick={() => props.onChange()}
              >
                <ArrowBackIosIcon />
              </div>
              <div className="ModalBox__header--label noselect">{props.modalLabel}</div>
            </div>
            <div className="ModalBox__content">{props.children}</div>
          </div>
        )}
      </div>
    );
  }
}

ModalBox.defaultProps = {
  modalActive: false
};

ModalBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  modalActive: PropTypes.bool,
  modalLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default ModalBox;
